import { render, staticRenderFns } from "./CheckoutInvestment.html?vue&type=template&id=bb739382&scoped=true&"
import script from "./CheckoutInvestment.ts?vue&type=script&lang=ts&"
export * from "./CheckoutInvestment.ts?vue&type=script&lang=ts&"
import style0 from "@/scss/components/checkout/_investment.scss?vue&type=style&index=0&id=bb739382&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb739382",
  null
  
)

export default component.exports